import { render, staticRenderFns } from "./modalNotasList.vue?vue&type=template&id=06e6a516&"
import script from "./modalNotasList.vue?vue&type=script&lang=js&"
export * from "./modalNotasList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports